<app-tenant-lookup-form
  [title]="title()"
  [message]="message()"
  [initialTenantName]="attemptedName()"
  [buttonText]="'Opnieuw Proberen'"
  [showInlineError]="true"
  (lookupSuccess)="onLookupSuccess($event)"
  (lookupError)="onLookupError($event)"
/>
